'use client';

import type { FeatureFlagAdapter } from './adapter.types';
import { FliptAdapter } from './flipt.adapter';
import { getE2ESnapshots, StaticFeatureFlagAdapter } from './static.adapter';

import { getFliptConfig } from '@/feature-flags/config';

export function createDefaultAdapter(): FeatureFlagAdapter {
  const snapshots = getE2ESnapshots();

  if (snapshots) {
    return new StaticFeatureFlagAdapter(snapshots);
  }

  const { url, apiToken } = getFliptConfig();

  if (!url) {
    throw new Error('Flipt URL is required to create the feature flag adapter');
  }

  return new FliptAdapter({ url, apiToken });
}
